<mat-dialog-content adEl>
  @for (message of messages; track $index) {
  <div adEl>{{message}}</div>
  }
</mat-dialog-content>
<mat-dialog-actions adEl>
  <button adEl="closeButton" mat-button (click)="closeDialog()">Close</button>
</mat-dialog-actions>
